export function isCreatorRole(role = "") {
  const normalized = String(role).toLocaleLowerCase("tr-TR");
  return ["oluşturucu", "olusturucu", "creator"].includes(normalized);
}

export function buildAracTakipAccess(role, userPermissions = {}) {
  const perms = userPermissions?.["arac-takip"] || userPermissions?.aractakip || {};
  const canAdmin = isCreatorRole(role) || perms.yonetici === true || perms.olusturucu === true;
  const canAdd = canAdmin || perms.giris === true || perms.ekler === true;
  const canView = canAdmin || canAdd || perms.takip === true || perms.gorur === true;

  return {
    canAdmin,
    canAdd,
    canView,
    canResolved:
      canView ||
      perms.cozulenler === true ||
      perms.cozuldu === true ||
      perms.resolved === true,
    canStats:
      canView ||
      perms.istatistik === true ||
      perms.istatistikler === true,
    canLogs: canAdmin || perms.loglar === true || perms.girisLoglari === true,
    canTermin: canAdmin || perms.termin === true || perms.terminAtama === true,
    canThreat: canAdmin || perms.tehdit === true || perms.tehditListesi === true,
  };
}
